export enum MenuButtons {
  StreetView = 'Street View',
  LocationSummary = 'Location Summary',
  SettingsAndCustomization = 'Settings And Customization',
  Tools = 'Tools',
  DeleteMarker = 'Delete Marker',
  NavigateToGoogle = 'NavigateToGoogle',
  NavigateToApple = 'NavigateToApple',
}
